import React from 'react';
import { compose } from 'redux';
import uniqueId from 'lodash/uniqueId';
import { withTranslation, WithTranslation } from 'react-i18next';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import { ListItemRadioButton } from '@wix/da-ds/pkg/List/ListItem';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import {
  withModuleConfig,
  WithModuleConfigProps,
} from '../../../_hoc/withModuleConfig';

export interface Props {
  moduleId: number;
  paramName: string;
  title?: string;
  className?: string;

  close: () => void;

  moduleConfig?: {
    options?: {
      type: string;
      selected?: boolean;
    }[];
  };
  labels: {
    [key: string]: string;
  };
}

const defaultProps = {
  title: 'common.sortOrder',
};

const enhance = compose(withModuleConfig, withTranslation());
export class SingleConfigFieldOptions extends React.Component<
  Props & WithTranslation & WithModuleConfigProps
> {
  readonly id = uniqueId('widget-edit-sortby');
  static defaultProps = defaultProps;

  render() {
    const { paramName, moduleConfig, labels, title, t } = this.props;
    if (!moduleConfig) {
      return <LoadingIndicator />;
    }
    const { [paramName]: options } = moduleConfig.options;

    return (
      <>
        <InputLabelText>{t!(title!)}</InputLabelText>
        {options.map(({ type, value = type, selected }) => (
          <ListItemRadioButton
            key={type}
            compact
            value={value}
            name={type}
            label={labels?.[value] ? t(labels[value]) : value}
            checked={selected}
            onChange={(isSelected, value) => this.handleChange(value)}
          />
        ))}
      </>
    );
  }
  handleChange = value => {
    const { paramName, saveModuleConfig, close } = this.props;
    const payload = {
      [paramName]: value,
    };
    saveModuleConfig(payload);
    close();
  };
}

export default enhance(SingleConfigFieldOptions) as React.ComponentType<Props>;
